import { aoikumoGet, parseAoikumoError } from './aoikumoApi';

export const state = {
  roomsByBranch: {},
  isLoading: false,
  isError: null, // { status, code, message } from the last failed fetch
};

export const getters = {
  getRooms: state => branchId => state.roomsByBranch[branchId] || [],
  isLoading(state) {
    return state.isLoading;
  },
  isError(state) {
    return state.isError;
  },
  getErrorMessage(state) {
    return state.isError ? state.isError.message : null;
  },
};

export const mutations = {
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setError(state, isError) {
    state.isError = isError;
  },
  setRooms(state, { branchId, rooms }) {
    state.roomsByBranch = { ...state.roomsByBranch, [branchId]: rooms };
  },
};

export const actions = {
  async fetchRooms({ commit, rootGetters }, { branchId }) {
    if (!branchId) return;
    const accountId = rootGetters.getCurrentAccountId;
    commit('setLoading', true);
    commit('setError', null);
    try {
      const { data } = await aoikumoGet(
        accountId,
        `/branches/${branchId}/rooms`
      );
      commit('setRooms', {
        branchId,
        rooms: data.map(room => ({ id: room.room_id, name: room.name })),
      });
    } catch (error) {
      commit('setRooms', { branchId, rooms: [] });
      commit('setError', parseAoikumoError(error));
    } finally {
      commit('setLoading', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
